const styles = ({ typography }) => ({
  scrollContainer: {
    minHeight: '100%',
  },
  fullScreenContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  centeredContainer: {
    width: '80%',
    height: '90%',
    position: 'absolute',
    top: '5%',
    left: '10%',
  },
  content: {
    backgroundColor: '#fafafa',
    width: '100%',
    height: '100%',
  },
});

export default styles;
